export const defaultArea = {
    'slug': '',
    'name': ''
}

export const sitename = 'Strakers'
export const sitenameseo="Strakers Estate Agents"

export const noImage = 'https://ggfx-Strakers.s3.eu-west-2.amazonaws.com/i.prod/coming_soon_large_e7f7a501b9.jpg'
